<template>
    <button
        :disabled="props.disabled"
        class="simple__button"
        :class="{
            'delete-button': iconName==='delete',
            'apply-button': iconName==='apply'
        }"
        @click="emit('click-button')"
    >
        <SvgIcon
            v-if="props.iconName"
            :name="props.iconName"
            class="simple__button-icon"
        />

        <UILoader v-if="props.loading" class="simple__button-loader" />

        <span v-else-if="!props.loading && props.text" class="simple__button-text">
            {{ props.text }}
        </span>

        <slot name="info" />
    </button>
</template>

<script>
export default {
    name: 'SimpleButton',
};
</script>

<script setup>
import SvgIcon from '@/components/ui/SvgIcon';
import UILoader from '@/components/ui/UILoader/index.vue';

const emit = defineEmits(['click-button']);

const props = defineProps({
    text: { type: String, default: '' },
    disabled: { type: Boolean },
    iconName: { type: String, default: '' },
    hideText: { type: Boolean },
    loading: { type: Boolean, default: false },
});
</script>

<style src="./styles.scss" lang="scss" scoped />
